import { USER_TYPE } from '../../../user/profile/consts';

const INITIAL_DETAILS = {
  name: '',
  displayName: '',
  telephone: '',
  email: '',
  company: '',
  projects: [],
  status: '',
  isLocked: false,
  passwordStatus: '',
  groups: [],
  policies: [],
  contractNumber: '',
  source: USER_TYPE.PLATFORM
};

const PERMISSION_TYPE = {
  EDIT: 'edit'
};

const ACTION_TYPE_MAP = {
  [PERMISSION_TYPE.EDIT]: 'edit'
};

const INITIAL_PERMISSION = {
  [PERMISSION_TYPE.EDIT]: false
};

export {
  INITIAL_DETAILS,
  INITIAL_PERMISSION,
  PERMISSION_TYPE,
  ACTION_TYPE_MAP
};
